import { render } from "./index.vue?vue&type=template&id=c3b61d32&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c3b61d32&scoped=true&lang=scss"

import exportComponent from "/var/www/amee/iptu-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b61d32"]])

export default __exports__